import { tbColors, tbPalette } from 'styles/colors';

const getMuiButton = () => ({
  styleOverrides: {
    root: {
      // Prevent default uppercase transformation on button labels
      textTransform: 'none',
      '&.MuiButton-contained': {
        fontWeight: 800,
      },
      '&.MuiButton-outlined, &.MuiButton-outlinedPrimary': {
        fontWeight: 800,
        border: '1px solid '.concat(tbColors.all.ash[900]),
        '&:hover, &.Mui-focusVisible': {
          border: '1px solid '.concat(tbColors.all.ash[900]),
          backgroundColor: tbPalette.background.bright,
        },
        '&:focus': {
          border: '1px solid '.concat(tbColors.all.ash[900]),
        },
        '&:disabled': {
          border: '1px solid '.concat(tbColors.all.ash[200]),
          backgroundColor: tbColors.all.snow[200],
        },
      },
      '&.MuiButton-text': {
        backgroundColor: 'transparent',
        '&:hover, &.Mui-focusVisible': {
          backgroundColor: 'transparent',
        },
      },
      variants: [],
    },
  },
});

export default getMuiButton;
